import BaseController from '../baseSystemController';
import { OP_WRAPPER_LOCALIZATION_PREFIX } from '../../../../utils/constants';
import eMainPopupControllerTypes from './eMainPopupControllerTypes';
import ControllerDropdown from '../../common/dropdown';

export default class ControllerRealityCheckMainPopup extends BaseController {
  constructor({ container, ...props }) {
    super({ ...props });
    this._eButtonsTypes = {
      EBT_SUBMIT: 'submit_button',
      EBT_QUIT: 'quit_button',
    };
    this._eEventTypes = {
      SUBMIT_CLICK: this.getEventName(this._eButtonsTypes.EBT_SUBMIT),
      QUIT_CLICK: this.getEventName(this._eButtonsTypes.EBT_QUIT),
    };
    this._eControllersClasses = {
      [this.controllerTypes.EPCT_DROPDOWN]: ControllerDropdown,
    }
    this._eElementsTypes = {
      EET_SCROLL_CONTAINER: 'scroll_container',
      EET_TIME_PLAYED_LABEL: 'time_played_label',
      EET_TIME_PLAYED_VALUE: 'time_played_value',
      EET_DESCRIPTION_0: 'description_0',
      EET_DESCRIPTION_1: 'description_1',
      EET_DESCRIPTION_2: 'description_2',
      EET_WIN_AMOUNT: 'win_amount',
      EET_BET_AMOUNT: 'bet_amount',
      EET_DROPDOWN_LABEL: 'dropdown_label',
      EET_CONTAINER_DROPDOWN: this.controllerTypes.EPCT_DROPDOWN,
      EET_BUTTON_SUBMIT: this._eButtonsTypes.EBT_SUBMIT,
      EET_BUTTON_QUIT: this._eButtonsTypes.EBT_QUIT,
    };

    this._localizations = {
      [this._eElementsTypes.EET_TIME_PLAYED_LABEL]: `${OP_WRAPPER_LOCALIZATION_PREFIX}.realityCheck.head`,
      [this._eElementsTypes.EET_DESCRIPTION_0]: `${OP_WRAPPER_LOCALIZATION_PREFIX}.realityCheck.desc_0`,
      [this._eElementsTypes.EET_DESCRIPTION_1]: `${OP_WRAPPER_LOCALIZATION_PREFIX}.realityCheck.desc_1`,
      [this._eElementsTypes.EET_DESCRIPTION_2]: `${OP_WRAPPER_LOCALIZATION_PREFIX}.realityCheck.desc_2`,
      [this._eElementsTypes.EET_DROPDOWN_LABEL]: `${OP_WRAPPER_LOCALIZATION_PREFIX}.realityCheck.next_notification`,
      [this._eElementsTypes.EET_BUTTON_SUBMIT]: `${OP_WRAPPER_LOCALIZATION_PREFIX}.realityCheck.continue`,
      [this._eElementsTypes.EET_BUTTON_QUIT]: `${OP_WRAPPER_LOCALIZATION_PREFIX}.realityCheck.closeGame`,
    }

    this.init(container);
  }

  _addExtraControllersListeners() {
    super._addExtraControllersListeners();
    const controllerDropdown = this.controllers[this.controllerTypes.EPCT_DROPDOWN];
    const scrollContainer = this.interactiveElements[this._eElementsTypes.EET_SCROLL_CONTAINER];

    controllerDropdown.on(controllerDropdown.events[this.controllerTypes.EPCT_DROPDOWN].DROPDOWN_TOGGLE, (visible) => {
      if (!visible) return;
      this._scrollTimeout = setTimeout(() => scrollContainer.scrollTo({ top: scrollContainer.scrollHeight, behavior: 'smooth' }), 300);
    });
  }

  cleanup() {
    super.cleanup();
    clearTimeout(this._scrollTimeout);
  }

  set timePlayed(value) {
    this.set(this._eElementsTypes.EET_TIME_PLAYED_VALUE, value);
  }

  set betAmount(value) {
    this.set(this._eElementsTypes.EET_BET_AMOUNT, `${value} ${window.OPWrapperService.model.data.partnerConfig.currency.toUpperCase()}`);
  }

  set winAmount(value) {
    this.set(this._eElementsTypes.EET_WIN_AMOUNT, `${value} ${window.OPWrapperService.model.data.partnerConfig.currency.toUpperCase()}`);
  }

  set timeoutOptions(options) {
    this.controllers[this.controllerTypes.EPCT_DROPDOWN].options = options;
  }

  set activeTimeout(value) {
    this.controllers[this.controllerTypes.EPCT_DROPDOWN].activeOption = value;
  }

  get controllerTypes() {
    return eMainPopupControllerTypes;
  }

  _getMarkup() {
    return `<div class="system-ui-container__modal__reality_check__container__body__scroll_container" id=${this.interactiveElementsIds[this._eElementsTypes.EET_SCROLL_CONTAINER]}>

        <div class="system-ui-container__modal__reality_check__container__time_played">
          <span id=${this.interactiveElementsIds[this._eElementsTypes.EET_TIME_PLAYED_LABEL]}>
            ${this._getLocalization(this._localizations[this._eElementsTypes.EET_TIME_PLAYED_LABEL])}
          </span>
          <span id=${this.interactiveElementsIds[this._eElementsTypes.EET_TIME_PLAYED_VALUE]}>
            00:00:00
          </span>
        </div>
        
        <div>
          <span id=${this.interactiveElementsIds[this._eElementsTypes.EET_DESCRIPTION_0]} class="system-ui-container__modal__reality_check__container__description">
            ${this._getLocalization(this._localizations[this._eElementsTypes.EET_DESCRIPTION_0])}
          </span>
          <span id=${this.interactiveElementsIds[this._eElementsTypes.EET_WIN_AMOUNT]} class="system-ui-container__modal__reality_check__container__description system-ui-container__modal__reality_check__container__description__highlight">
          </span>
          <span id=${this.interactiveElementsIds[this._eElementsTypes.EET_DESCRIPTION_1]} class="system-ui-container__modal__reality_check__container__description">
            ${this._getLocalization(this._localizations[this._eElementsTypes.EET_DESCRIPTION_1])}
          </span>
          <span id=${this.interactiveElementsIds[this._eElementsTypes.EET_BET_AMOUNT]} class="system-ui-container__modal__reality_check__container__description system-ui-container__modal__reality_check__container__description__highlight">
          </span>
          <span id=${this.interactiveElementsIds[this._eElementsTypes.EET_DESCRIPTION_2]} class="system-ui-container__modal__reality_check__container__description">
            ${this._getLocalization(this._localizations[this._eElementsTypes.EET_DESCRIPTION_2])}
          </span>
        </div>
        
        <div class="system-ui-container__modal__reality_check__container__container_dropdown">
          <span id=${this.interactiveElementsIds[this._eElementsTypes.EET_DROPDOWN_LABEL]}>
            ${this._getLocalization(this._localizations[this._eElementsTypes.EET_DROPDOWN_LABEL])}
          </span>
          <div id=${this.interactiveElementsIds[this._eElementsTypes.EET_CONTAINER_DROPDOWN]}>
          </div>
        </div>
        </div>
        
        <div class="system-ui-container__modal__reality_check__container__submit_wrapper">
          <div class="system-ui-container__modal__reality_check__container__submit_wrapper__controls">
            <button id=${this.interactiveElementsIds[this._eElementsTypes.EET_BUTTON_SUBMIT]} class="system-ui-container__modal__reality_check__container__submit_wrapper__controls__submit">
               ${this._getLocalization(this._localizations[this._eElementsTypes.EET_BUTTON_SUBMIT])}
            </button>
            <button id=${this.interactiveElementsIds[this._eElementsTypes.EET_BUTTON_QUIT]} class="system-ui-container__modal__reality_check__container__submit_wrapper__controls__quit">
               ${this._getLocalization(this._localizations[this._eElementsTypes.EET_BUTTON_QUIT])}
            </button>
          </div>
        </div>`
  }
}
